function prevencao(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Para prevenir a doença: lavar muito bem as mãos e higienizar objetos de uso diário com água e sabão ou álcool 70; manter distância mínima de 1,5 metros das outras pessoas e utilizar  máscara corretamente.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"Evitar: contato físico com outras pessoas; tocar seus olhos, nariz, boca ou a máscara sem higienizar as mãos antes; compartilhar objetos de uso pessoal; aglomerações.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/prevencao/1.png"
			}
		]
	};
}

export {prevencao};
